import { Box, Button, Card, CardContent, Typography } from '@mui/material'
import Tooltip from './ReportTooltip'
import RestartAltRoundedIcon from '@mui/icons-material/RestartAltRounded'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import DateRangeFilter from '../../../components/DateRangeFilter'
import InlineInfoNote from '../../../components/InlineInfoNote'
import UserReportDownloadComponent from './UserReportDownloadComponent'

const SharedUserReportHeader = ({
  dateRangeValue,
  onDateRangeChange,
  onResetDateRange,
  showReset = false,
  downloadProps = {},
  downloadContent = null,
  noteMessage = 'Solo puedes escoger un rango de fechas máximo de 12 meses.',
  compactPeriodNote = true
}) => (
  <Card
    className="report-period-card"
    elevation={0}
    sx={{
      mt: 3,
      borderRadius: '16px',
      border: '1px solid #d6e1ed'
    }}
  >
    <CardContent
      sx={{
        px: { xs: 1.5, sm: '20px' },
        py: { xs: 1.5, sm: '16px' },
        '&:last-child': { pb: { xs: 1.5, sm: '16px' } }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: { xs: 'stretch', md: 'flex-start' },
            justifyContent: 'space-between',
            gap: 2,
            flexWrap: { xs: 'wrap', md: 'nowrap' }
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: { xs: 'stretch', sm: 'center' },
              flexWrap: 'wrap',
              gap: '18px',
              minWidth: 0,
              flex: '1 1 360px',
              '& .react-filter-box': {
                marginTop: 0
              }
            }}
          >
            <Typography className="report-period-title">Periodo de búsqueda</Typography>

            <DateRangeFilter
              value={dateRangeValue}
              onChange={onDateRangeChange}
              inputTitle="Periodo de búsqueda"
              variant="modern"
              maxRangeMonths={12}
            />

            {compactPeriodNote && (
              <Tooltip title={noteMessage} arrow placement="top">
                <Box
                  component="span"
                  className="report-period-note"
                  tabIndex={0}
                  aria-label={noteMessage}
                  sx={{
                    '&:focus-visible': {
                      outline: '2px solid #7899bd',
                      outlineOffset: '2px'
                    }
                  }}
                >
                  <InfoOutlinedIcon sx={{ width: 14, height: 14, flexShrink: 0, m: 0 }} />
                  <span>Máx. 12 meses</span>
                </Box>
              </Tooltip>
            )}

            {showReset && (
              <Button
                variant="text"
                size="small"
                onClick={onResetDateRange}
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.5,
                  color: '#597FA9',
                  cursor: 'pointer',
                  minWidth: 'auto',
                  minHeight: 24,
                  px: 1.25,
                  py: 0,
                  fontSize: 10,
                  fontWeight: 500,
                  lineHeight: 1,
                  whiteSpace: 'nowrap',
                  textTransform: 'none',
                  borderRadius: 999,
                  '& .MuiSvgIcon-root': {
                    width: 14,
                    height: 14
                  },
                  '&:hover': { backgroundColor: '#f1f5f9' }
                }}
              >
                <RestartAltRoundedIcon aria-hidden="true" />
                <span>Restablecer</span>
              </Button>
            )}
          </Box>

          <Box
            className="user-report-download-action"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
              flexWrap: 'wrap',
              ml: { xs: 0, md: 'auto' },
              flexShrink: 0,
              '& .download-doble-reports, & .download-doble-reports-arrow': {
                height: '38px !important'
              }
            }}
          >
            {downloadContent || <UserReportDownloadComponent {...downloadProps} />}
          </Box>
        </Box>

        {!compactPeriodNote && (
          <InlineInfoNote
            title="Nota:"
            message={noteMessage}
            singleLine
            sx={{
              width: '100%'
            }}
          />
        )}
      </Box>
    </CardContent>
  </Card>
)

export default SharedUserReportHeader
